import _schedules                          from './schedules';
import _hours                              from './hours';
import _substitutionPlans                  from './substitution-plans';
import _classes                            from './classes';
import _teachers                           from './teachers';
import _subjects                           from './subjects';
import _rooms                              from './rooms';
import _courses                            from './courses';
import _lessons                            from './lessons';
import _holidays                           from './holidays';
import _schoolYears                        from './school-years';

export default {
  schedules:         _schedules,
  hours:             _hours,
  substitutionPlans: _substitutionPlans,
  classes:           _classes,
  teachers:          _teachers,
  subjects:          _subjects,
  rooms:             _rooms,
  courses:           _courses,
  lessons:           _lessons,
  holidays:          _holidays,
  schoolYears:       _schoolYears
};